import { useQueries } from "@tanstack/react-query";
import { api } from "../../api/client";
import type { BondSchedule } from "../bond/useBondSchedule";

// Параллельный fetch расписаний для набора secid'ов. queryKey совпадает с
// useBondSchedule, поэтому один и тот же кеш разделяется между дашбордом и
// карточкой бумаги — открыл бонд → расписание уже в кеше дашборда, и наоборот.
export function useSchedulesByPosition(secids: string[]): {
  byId: Map<string, BondSchedule>;
  isLoaded: boolean;
} {
  const queries = useQueries({
    queries: secids.map((secid) => ({
      queryKey: ["bond-schedule", secid],
      queryFn: async ({ signal }: { signal?: AbortSignal }) => {
        const { data, error } = await api.GET("/api/bond/{secid}/schedule", {
          signal,
          params: { path: { secid } },
        });
        if (error || !data) throw new Error(String(error ?? "no data"));
        return data;
      },
      staleTime: 60 * 60_000,
    })),
  });
  const byId = new Map<string, BondSchedule>();
  queries.forEach((q, i) => {
    if (q.data) byId.set(secids[i], q.data);
  });
  const isLoaded = queries.length === 0 || queries.every((q) => q.data || q.isError);
  return { byId, isLoaded };
}
